// @flow

import gql from 'graphql-tag';

const earlyAccessButtonQuery = gql`
  query earlyAccessButtonQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      image
      name
      inviteUrl
    }
  }
`;

export default earlyAccessButtonQuery;
